export const concatPathWithBackendUrl = (path: any): string => {
  if (typeof path !== "string") {
    return "";
  }

  if (path.includes("http")) {
    return path;
  } else {
    return process.env.REACT_APP_BASE_URL_PREFIX + "/uploads/" + path;
  }
};
